/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	
	  (0, _module.preload)();
	  (0, _module.anchorLink)();
	  (0, _module.toggleMenu)();
	  (0, _module.imgSlider)();
	  (0, _module.toggleMovie)();
	  (0, _module.animeScroll)();
	  (0, _module.animeLoad)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	function videoControl(action, target) {
	  var $playerWindow = $(target)[0].contentWindow;
	  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
	}
	
	var preload = function preload() {
	  $(window).on("load", function () {
	    $("body").css("opacity", "");
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// toggleMenu
	// ------------------------------------------------------------------------
	var toggleMenu = function toggleMenu() {
	  $('.header-hamburger').on('click', function () {
	    if ($(this).hasClass("movie")) {
	      $(".st-Movie").removeClass("open");
	      $(".header-hamburger button").removeClass("open");
	      $(".header-hamburger").removeClass("open").removeClass("movie");
	      $('#youtube-modal').attr("src", "");
	    } else {
	      $(this).toggleClass("open");
	      $(".header-nav").toggleClass("open");
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// imgSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	var imgSlider = function imgSlider() {
	  if ($('.box-slider').length) {
	    var _$$slick;
	
	    $('.box-slider').slick((_$$slick = {
	      autoplay: true,
	      autoplaySpeed: 5000,
	      infinite: true,
	      slidesToShow: 1,
	      dots: true,
	      speed: 800
	    }, _defineProperty(_$$slick, 'slidesToShow', 1), _defineProperty(_$$slick, 'centerMode', true), _defineProperty(_$$slick, 'focusOnSelect', true), _defineProperty(_$$slick, 'variableWidth', true), _defineProperty(_$$slick, 'responsive', [{
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 1
	      }
	    }]), _$$slick));
	  }
	};
	
	// ------------------------------------------------------------------------
	// toggleMovie
	// ------------------------------------------------------------------------
	var toggleMovie = function toggleMovie() {
	  var ua = navigator.userAgent;
	  $(".movie-toggle").on("click", function () {
	    var youtubeId = $(this).data("youtube");
	    var embedUrl = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&mute=1&enablejsapi=1";
	    $(".st-Movie").toggleClass("open");
	    $(".header-hamburger button").toggleClass("open");
	    $(".header-hamburger").toggleClass("open").toggleClass("movie");
	    $('#youtube-modal').attr("src", embedUrl);
	    $('#youtube-modal').on('load', function () {
	      videoControl("playVideo", '#youtube-modal');
	      if (/android/i.test(ua)) {
	        videoControl("unMute", '#youtube-modal');
	      }
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// animeScroll
	// ------------------------------------------------------------------------
	var animeScroll = function animeScroll() {
	  $(window).on("load", function () {
	    $(".anim-sc").each(function (i, node) {
	      gsap.to(node, {
	        scrollTrigger: {
	          trigger: node,
	          start: 'top bottom-=200',
	          toggleClass: { targets: node, className: "animated" },
	          once: true
	        }
	      });
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// animeLoad
	// ------------------------------------------------------------------------
	var animeLoad = function animeLoad() {
	  $(window).on("load", function () {
	    $(".anim-ld").toggleClass("animated");
	  });
	};
	
	exports.preload = preload;
	exports.imgSlider = imgSlider;
	exports.anchorLink = anchorLink;
	exports.toggleMenu = toggleMenu;
	exports.toggleMovie = toggleMovie;
	exports.animeScroll = animeScroll;
	exports.animeLoad = animeLoad;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js